export * from './ITabsState';
export * from './ITabsProps';
export * from './ITabsConfiguration';
export * from './ITabsOwnProps';
export * from './ITabsDispatchProps';
export * from './ICommentsTab';
export * from './IAudioMetadata';
